import React, { useState } from "react";
import {History, Printer} from "lucide-react"
import {BarChart3} from "lucide-react"
import {
  Navbar,
  OverlayTrigger,
  Popover,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Logo from "../../Assets/OrderlyFullTextLogo.png";
import { User } from "lucide-react";
import { LogOut } from "lucide-react";
import { useDispatch } from "react-redux";
import { logout } from "../../features/authSlice";
import style from "./Navbar.module.scss"
import { APP_ROUTES_PATHS } from "../../utils/constants/appRoutes";
import { clearAuthSession, getAuthRole } from "../../renderer/platform/authStorage";
import { isElectron } from "../../renderer/platform";

/**
 *  Header/Navbar component for the page, renders on App.js component.
 * @component
 * @returns {JSX.element} - returns jsxLogo1-fotor-bg-remover-2025051614958 element.
 * @author - s
 */
function HeaderNav() {

//For selecting user role saved in local storage
  const userRole = getAuthRole();

  //Uselocation and use navigate hook used for managing paths 
  const navigate = useNavigate();
  
  //UseDispatch function for dispatching redux methods
  const dispatch = useDispatch();
  
  // State for controlling popover
  const [showPopover, setShowPopover] = useState(false);
  
  // Function to handle logo navigation based on user role
  const handleLogoClick = () => {
      navigate(`/`)
    }  
    
  // Function to handle menu item clicks and close popover
  const handleMenuItemClick = (action) => {
    setShowPopover(false);
    action();
  };  
  // Pop over component for the User section.
  const popover = (
    <Popover id="popover-basic">
      <Popover.Body className="p-2">
        {/* <div className="d-flex gap-2 align-items-center popover-item">
          <User height={22} />
          <span className="popover-text">Account</span>
        </div> */}
        {userRole === 'cashier' && (
          <div onClick={() => handleMenuItemClick(() => navigate(APP_ROUTES_PATHS.RECENT_ORDERS_PATH))} className="d-flex gap-2 align-items-center popover-item">
            <History height={20} />
            <span className="popover-text">Recent Orders</span>
          </div>
        )}
        {userRole === 'cashier' && (
          <div onClick={() => handleMenuItemClick(() => navigate(APP_ROUTES_PATHS.REPORTS_PATH))} className="d-flex gap-2 align-items-center popover-item">
            <BarChart3 height={20} />
            <span className="popover-text">Reports</span>
          </div>
        )}
        {isElectron() && (
          <button
            type="button"
            onClick={() => handleMenuItemClick(() => navigate(APP_ROUTES_PATHS.PRINTER_SETTINGS_PATH))}
            className="d-flex gap-2 align-items-center popover-item border-0 bg-transparent w-100 text-start"
          >
            <Printer height={20} />
            <span className="popover-text">Printer Settings</span>
          </button>
        )}
        <div onClick={() => handleMenuItemClick(async () => {await clearAuthSession(); dispatch(logout()); navigate("/"); window.location.reload();})} className="d-flex gap-2 align-items-center popover-item logout-item">
          <LogOut color="red" height={20} />
          <span className="popover-text">Logout</span>
        </div>
      </Popover.Body>
    </Popover>
  );

  return (
    <Navbar expand="lg" className={`custom-navbar shadow-sm px-3 ${style.NavBar}`}>
      <div className="d-flex justify-content-between w-100">
        <div 
          className="cursor-pointer" 
          onClick={handleLogoClick}
          title="Go to Home"
        >
          <img alt="Logo" src={Logo} height="50" className="d-inline-block align-top" />
        </div>

        <div className="ms-auto d-flex gap-4 pr-10">
          <OverlayTrigger
            trigger="click"
            placement="bottom-end"
            overlay={popover}
            show={showPopover}
            onToggle={setShowPopover}
            rootClose
          >
            <div
              className={`${style.UserCircle}`}
            >
              <User size={30} />
            </div>
          </OverlayTrigger>
        </div>
      </div>
    </Navbar>
  );
}

export default HeaderNav;
